async function handlelinked_products(linked_products) {
  try {
    const response = await fetch('/cart.js'); // Récupère le panier mis à jour
    const cart = await response.json();

    const linked_productsToAdd = [];

    // Parcourt les produits du panier
    for (const item of cart.items) {
      const linkedProductData = linked_products[item.key];

      // Vérifie si linkedProductData existe et si required_crate est true
      if (linkedProductData && linkedProductData.required_crate === true) {
        const linkedVariantId = parseInt(linkedProductData.id);

        // Vérifie si le produit lié est déjà dans le panier
        const isLinkedProductInCart = cart.items.some(
          (cartItem) =>
            cartItem.variant_id === linkedVariantId &&
            cartItem.properties &&
            cartItem.properties._linkedToParent === item.key
        );

        // Ajoute le produit lié s'il n'est pas encore dans le panier
        if (!isLinkedProductInCart) {
          linked_productsToAdd.push({
            id: linkedVariantId,
            quantity: item.quantity,
            properties: {
              _linkedToParent: item.key,
              _linkedProduct: true,
              _AddByCountry: true
            }
          });
        }
      } else {
        console.log(
          `Le produit lié pour l'élément ${item.key} est ignoré car required_crate est false ou manquant.`
        );
      }
    }

    // Ajoute les produits liés
    if (linked_productsToAdd.length > 0) {
      for (const product of linked_productsToAdd) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: product.id,
            quantity: product.quantity,
            properties: product.properties,
          }),
        });
      }
      console.log('Produits liés ajoutés au panier.');
    }

    // Supprime les produits liés si le produit parent n'est plus présent
    for (const item of cart.items) {
      if (item.properties && item.properties._linkedToParent) {
        const parentKey = item.properties._linkedToParent;

        const isParentInCart = cart.items.some(
          (cartItem) => cartItem.key === parentKey
        );

        if (!isParentInCart) {
          console.log(`Suppression du produit lié : ${item.key} car le parent est absent.`);
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 0,
            }),
          });
        }
      }
    }
  } catch (error) {
    console.error('Erreur lors de la gestion des produits liés :', error);
  }
}

document.addEventListener('DOMContentLoaded', function () {
    const addCrateButtons = document.querySelectorAll('.btn-add-a-crate');
  
    addCrateButtons.forEach((button) => {
      button.addEventListener('click', async function () {
        const linkedProductId = button.dataset.id;
        const parentKey = button.dataset.parentKey;
        const parentQuantity = parseInt(button.dataset.parentQuantity, 10);
  
        console.log('ID du produit lié :', linkedProductId);
        console.log('Parent Key :', parentKey);
        console.log('Parent Quantity :', parentQuantity);
  
        if (!linkedProductId || isNaN(parentQuantity)) {
          console.error('Données manquantes ou incorrectes.');
          return;
        }
  
        try {
          // Étape 1 : Ajouter la classe "crate-added" à l'élément correspondant
          const parentElement = document.querySelector(`[data-item-key="${parentKey}"]`);
          if (parentElement) {
            console.log(`Ajout de la classe 'crate-added' à l'élément avec data-item-key="${parentKey}"`);
            parentElement.classList.add('crate-added');
          }
  
          // Étape 2 : Attendre un court délai avant de procéder à l'ajout
          await new Promise((resolve) => setTimeout(resolve, 50)); // Délai de 500ms
  
          // Étape 3 : Envoyer la requête d'ajout au panier
          const payload = {
            id: linkedProductId,
            quantity: parentQuantity,
            properties: {
              _linkedToParent: parentKey,
              _linkedProduct: true,
              _AddByCountry: false
            },
          };
  
          console.log('Données envoyées à /cart/add.js:', payload);
  
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
  
          if (!response.ok) {
            const errorData = await response.json();
            console.error("Erreur lors de l'ajout au panier:", errorData);
            return;
          }
  
          console.log('Produit lié ajouté avec succès.');
  
          // Étape 4 : Déclenche l'événement pour rafraîchir le panier
          window.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
          console.error('Erreur lors de la requête POST :', error);
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const removeCrateButtons = document.querySelectorAll('.btn-remove-a-crate');
  
    removeCrateButtons.forEach((button) => {
      button.addEventListener('click', async function () {
        const linkedItemKey = button.dataset.key;
  
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: linkedItemKey,
              quantity: 0
            })
          });
  
          console.log('Caisse supprimée avec succès.');
          window.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
          console.error('Erreur lors de la suppression de la caisse :', error);
        }
      });
    });
  });
  

document.addEventListener('cart:updated', () => {
  if (typeof linked_products !== 'undefined') {
    console.log('linked_products:', linked_products);

    // Vérifier si au moins un produit a required_crate: true
    const isCrateRequired = Object.values(linked_products).some(
      (product) => product.required_crate === true
    );

    if (isCrateRequired) {
      console.log('Produits liés requis.');
      handlelinked_products(linked_products);
    } else {
      console.log('Aucun produit lié requis.');
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (typeof linked_products !== 'undefined') {
    console.log('linked_products:', linked_products);

    // Vérifier si au moins un produit a required_crate: true
    const isCrateRequired = Object.values(linked_products).some(
      (product) => product.required_crate === true
    );

    if (isCrateRequired) {
      console.log('Produits liés requis.');
      handlelinked_products(linked_products);
    } else {
      console.log('Aucun produit lié requis.');
    }
  }
});